import React from 'react';
import { Link } from 'react-router-dom';

import { images } from '../../assets/images';
import { routes } from '../../routes';

function Events() {
    return (
        <>
        <div className="shadowed_whitebox p-3 p-lg-4 news_recent_posts mb-4">
            <div className="sidebar_title">
                Recent Posts
                <hr />
            </div>
            <div className="recent_post_item d-flex">
                <div className="img_area">
                    <Link to={routes.newsdetail}>
                        <img src={images.process2} className="img-fluid" alt="..." />
                    </Link>
                </div>
                <div className="info_area">
                    <h5>
                        <Link to={routes.newsdetail}>
                            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quia, voluptate
                        </Link>
                    </h5>
                    <div className="recent_post_date">
                        <i className="far fa-calendar-alt"></i>
                        <span>January 21, 2021</span>
                    </div>
                </div>
            </div>
            <div className="recent_post_item d-flex">
                <div className="img_area">
                    <Link to={routes.newsdetail}>
                        <img src={images.process2} className="img-fluid" alt="..." />
                    </Link>
                </div>
                <div className="info_area">
                    <h5>
                        <Link to={routes.newsdetail}>
                            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quia, voluptate
                        </Link>
                    </h5>
                    <div className="recent_post_date">
                        <i className="far fa-calendar-alt"></i>
                        <span>January 21, 2021</span>
                    </div>
                </div>
            </div>
            <div className="recent_post_item d-flex">
                <div className="img_area">
                    <Link to={routes.newsdetail}>
                        <img src={images.process2} className="img-fluid" alt="..." />
                    </Link>
                </div>
                <div className="info_area">
                    <h5>
                        <Link to={routes.newsdetail}>
                            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quia, voluptate
                        </Link>
                    </h5>
                    <div className="recent_post_date">
                        <i className="far fa-calendar-alt"></i>
                        <span>January 21, 2021</span>
                    </div>
                </div>
            </div>
            <div className="recent_post_item d-flex">
                <div className="img_area">
                    <Link to={routes.newsdetail}>
                        <img src={images.process2} className="img-fluid" alt="..." />
                    </Link>
                </div>
                <div className="info_area">
                    <h5>
                        <Link to={routes.newsdetail}>
                            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quia, voluptate
                        </Link>
                    </h5>
                    <div className="recent_post_date">
                        <i className="far fa-calendar-alt"></i>
                        <span>January 21, 2021</span>
                    </div>
                </div>
            </div>
            <div className="recent_post_item d-flex">
                <div className="img_area">
                    <Link to={routes.newsdetail}>
                        <img src={images.process2} className="img-fluid" alt="..." />
                    </Link>
                </div>
                <div className="info_area">
                    <h5>
                        <Link to={routes.newsdetail}>
                            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quia, voluptate
                        </Link>
                    </h5>
                    <div className="recent_post_date">
                        <i className="far fa-calendar-alt"></i>
                        <span>January 21, 2021</span>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
    }

export default Events;